import type { GetServerSideProps } from 'next'
import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { Hero } from '@/components/sections/hero'
import { DashboardSection } from '@/components/sections/dashboard'
import { FeaturesSection } from '@/components/sections/features'
import { CapabilitiesSection } from '@/components/sections/capabilities'
import { TestimonialsSection } from '@/components/sections/testimonials'
import { PricingSection } from '@/components/sections/pricing'
import { BlogSection } from '@/components/sections/blog-section'
import { CtaSection } from '@/components/sections/cta-section'
import { getAllPosts, type BlogPost } from '@/lib/db/posts'

interface HomeProps {
    posts: BlogPost[]
}

const Home: FC<HomeProps> = ({ posts }): ReactNode => {
    return (
        <>
            <Seo />
            <Layout>
                <Hero />
                <DashboardSection />
                <FeaturesSection />
                <CapabilitiesSection />
                <TestimonialsSection />
                <PricingSection />
                <BlogSection posts={posts} />
                <CtaSection />
            </Layout>
        </>
    )
}

export const getServerSideProps: GetServerSideProps<HomeProps> = async () => {
    const posts = await getAllPosts()
    return { props: { posts } }
}

export default Home
